/**
 * Wrapper around <PromotionBadge /> from component-library to add internal category to ui type mapping.

 */

import type {PromotionCategory} from '@/redux/v1/models';
import type {ExtractPropsWithoutRef} from '@/types';

import {
  LabelXSmall,
  PROMOTION_TYPE_FLEX as PROMOTION_BADGE_TYPE_FLEX,
  PROMOTION_TYPE_SAFETY as PROMOTION_BADGE_TYPE_SAFETY,
  PROMOTION_TYPE_SPECIAL as PROMOTION_BADGE_TYPE_SPECIAL,
  PromotionBadge as UIPromotionBadge,
  Stack,
  Tooltip,
} from '@travel-frontend/ui-components';

import {
  PROMOTION_CATEGORY_FLEX,
  PROMOTION_CATEGORY_SAFETY,
  PROMOTION_CATEGORY_SPECIAL,
} from '@/redux/v1/models';

const PROMOTION_BADGE_TYPE_BY_CATEGORY = {
  [PROMOTION_CATEGORY_SPECIAL]: PROMOTION_BADGE_TYPE_SPECIAL,
  [PROMOTION_CATEGORY_FLEX]: PROMOTION_BADGE_TYPE_FLEX,
  [PROMOTION_CATEGORY_SAFETY]: PROMOTION_BADGE_TYPE_SAFETY,
};

type Props = Omit<ExtractPropsWithoutRef<typeof UIPromotionBadge>, 'type'> & {
  category: PromotionCategory;
  tooltip?: string;
};

export const PromotionBadge: React.FunctionComponent<Props> = ({
  category,
  tooltip,
  ...restProps
}) => {
  const type = PROMOTION_BADGE_TYPE_BY_CATEGORY[category];
  const badge = <UIPromotionBadge {...restProps} type={type} />;

  if (tooltip) {
    return (
      <Tooltip
        placement="top"
        content={
          <Stack spacing={0.25}>
            <UIPromotionBadge type={type} />
            <LabelXSmall dangerouslySetInnerHTML={{__html: tooltip}} />
          </Stack>
        }
        data-interaction-trigger
      >
        {badge}
      </Tooltip>
    );
  }
  return badge;
};
